import React from 'react';
import { Link } from 'react-router-dom';

import { Icon, IconNewTab } from '@flixbus/honeycomb-icons-react';
import { Button, Tag } from '@flixbus/honeycomb-react';

import { crewDataNA, EB_OPERATOR_LABEL, RRO_OPERATOR_LABEL } from 'constants/crewDetails';

import { returnJobCardText } from './text';

import styles from '../styles.module.css';

const getClassificationLabel = (currentRun) => {
	return currentRun === undefined
		? crewDataNA
		: currentRun === null
			? EB_OPERATOR_LABEL
			: RRO_OPERATOR_LABEL;
};

const ReturnJobCard = ({ card, onSelect, variant = 'default' }) => (
	<div
		className={`${styles.sequenceCard} ${variant === 'selected' ? styles.selectedCard : variant === 'default' ? styles.defaultCard : ''}`}
	>
		<div className={styles.sequenceTitle}>
			<span className={styles.sequenceHeaderItem}>
				{returnJobCardText.runPrefix} {card.runName}
			</span>
			<span className={styles.sequenceHeaderItem}>
				{returnJobCardText.jobPrefix} {card.jobCode}
			</span>
		</div>
		<div className={styles.routeText}>{card.route}</div>
		<div className={styles.metaRow3}>
			<div className={styles.metaBlock}>
				<div className={styles.metaLabel}>{returnJobCardText.plannedDeparture}</div>
				<div className={styles.metaValue}>{card.plannedDeparture}</div>
			</div>
			<div className={styles.metaBlock}>
				<div className={styles.metaLabel}>{returnJobCardText.plannedArrival}</div>
				<div className={styles.metaValue}>{card.plannedArrival}</div>
			</div>
			<div className={styles.metaBlock}>
				<div className={styles.metaLabel}>{returnJobCardText.mileage}</div>
				<div className={styles.metaValue}>{card.mileage}</div>
			</div>
		</div>
		<div className={styles.metaRow2}>
			<div className={styles.metaBlock}>
				<div className={styles.metaLabel}>{returnJobCardText.duration}</div>
				<div className={styles.metaValue}>{card.duration}</div>
			</div>
			{card.assigneeName && (
				<div className={styles.metaBlock}>
					<div className={styles.metaLabel}>{returnJobCardText.assignee}</div>
					<div className={styles.assigneeValue}>
						<span className={styles.metaValue}>{card.assigneeName}</span>
						<Tag display="outlined" small>
							{getClassificationLabel(card.assigneeCurrentRun)}
						</Tag>
						{card.assigneeId && (
							<Link to={`/crew-management/${card.assigneeId}`} target="_blank">
								<Icon InlineIcon={IconNewTab} size={3} />
							</Link>
						)}
					</div>
				</div>
			)}
		</div>
		{onSelect && (
			<div className={styles.selectAction}>
				<Button appearance="primary" onClick={onSelect}>
					{returnJobCardText.selectButton}
				</Button>
			</div>
		)}
	</div>
);

export default ReturnJobCard;
